import clsx from "clsx";

import { OptimizationStatus } from "@web-app/types";

export default function StatusBadge({
  status,
}: {
  status: OptimizationStatus;
}) {
  return (
    <span
      className={clsx(
        "rounded px-2 py-0.5 text-xs font-medium",
        status === "SENT"
          ? "bg-green-100 text-green-700"
          : "bg-gray-100 text-gray-600",
      )}
    >
      {status === "SENT" ? "Sent" : "Draft"}
    </span>
  );
}
